import { PreconfiguredGivingLinksApiConfig } from './preconfigured-giving-links-generated';
import { dataService } from '../../Shared/utils/data-service';

const ds = dataService(PreconfiguredGivingLinksApiConfig).getPromiseService();

export const preconfiguredGivingLinksDataService = ds;
